import type { ICurrency } from '@/interfaces'

export class Currency implements ICurrency {
	code: string
	name: string
	isoCode: string
	constructor({ code, name, isoCode }: ICurrency) {
		this.code = code
		this.name = name
		this.isoCode = isoCode
	}
}
